import request from '@/utils/request'

const url = 'village'

/** 获取小区下拉框 */
export function searchVillageSelectList(data) {
  return request({
    url: `${url}/searchVillageSelectList`,
    method: 'post',
    data
  })
}

/** 获取小区列表 */
export function searchVillageList(data) {
  return request({
    url: `${url}/searchVillageList`,
    method: 'post',
    data
  })
}

/** 查看小区 */
export function getVillageInfo(data) {
  return request({
    url: `${url}/getVillageInfo`,
    method: 'post',
    data
  })
}

/** 添加小区 */
export function insertVillageInfo(data) {
  return request({
    url: `${url}/insertVillageInfo`,
    method: 'post',
    data
  })
}

/** 编辑小区 */
export function editVillageInfo(data) {
  return request({
    url: `${url}/editVillageInfo`,
    method: 'post',
    data
  })
}

/** 删除小区 */
export function deleteVillageInfo(data) {
  return request({
    url: `${url}/deleteVillageInfo`,
    method: 'post',
    data
  })
}
